import VueSVGIcon from 'vue-svgicon';
import Vue from 'vue';

Vue.use(VueSVGIcon);
